/**
 * main.tsx — mount + provider (Workspace-Structure §4)
 *
 * 🔄 แทนที่ `src/main.ts` (`export {}`) ของ scaffold — นามสกุลต้องเป็น `.tsx`
 *    เพราะไฟล์นี้มี JSX · `index.html` ชี้มาที่ `/src/main.tsx`
 */
/**
 * 🔴 **design token โหลดที่นี่ที่เดียวของแอป** (คู่กับ `.storybook/preview.ts` ของ Storybook)
 *    feature เขียนแต่ `var(--elite-…)` โดยไม่รู้ค่าจริง (handbook: assumption-free)
 *    ⇒ ลืมบรรทัดนี้ = ทั้งแอปไม่มีสี แต่ story มีสี (แล้วจะไล่หาบั๊กผิดที่)
 */
import '@theelite/ui/tokens.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.js';
import { createAppRouter } from './composition/index.js';

const rootElement = document.getElementById('root');
if (rootElement === null) throw new Error('ไม่พบ #root ใน index.html');

/**
 * config ที่ขาดจะ throw ที่นี่ (ก่อน render) — แสดงข้อความบนหน้าจอตรง ๆ
 * ⚠️ ปล่อยให้ throw เฉย ๆ = หน้าขาว + error ใน console ที่ผู้ใช้ไม่เปิดดู
 *    ซึ่งกับกลุ่มผู้ใช้ 60+ เท่ากับ "แอปพัง" โดยไม่มีใครรู้ว่าเพราะอะไร
 */
try {
  const router = createAppRouter();
  createRoot(rootElement).render(
    <StrictMode>
      <App router={router} />
    </StrictMode>,
  );
} catch (err) {
  const message = err instanceof Error ? err.message : 'เริ่มต้นแอปไม่สำเร็จ';
  // textContent ไม่ใช่ innerHTML — ข้อความมาจาก error ที่เราไม่ได้ควบคุมทั้งหมด
  const heading = document.createElement('h1');
  heading.textContent = 'ตั้งค่าแอปไม่ครบ';
  const detail = document.createElement('p');
  detail.textContent = message;
  rootElement.append(heading, detail);
}
